import {API} from 'aws-amplify';
import axios from 'axios';

const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === 'true';
const baseURL = process.env.REACT_APP_APIURL;

export const loginApi = ({ email, password, idToken, token }) => {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/user/login`, { email, password }).then(res => res.data);
  }
  return API.post('Backend', "/user/login", { body: { email, password, idToken } });
};
